import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import './Gallery.css';
import { withVersion } from '../utils/mediaVersion';
var photoFiles = [
    'background_better.png',
    'background.jpg',
    'bottles_with_cork.png',
    'bottles-with-cork-rose.jpg',
    'Cheers.jpg',
    'estate.png',
    'grapes-photo-closeup.png',
    'Grapes.png',
    'grapes2.jpg',
    'grapes3.jpg',
    'harvested_grapes.jpg',
    'kamea-bg.png',
    'labels.png',
    'rosepic.jpg',
    'stylish_wines.png',
    'winemaker.jpg',
    'winter_wine.png',
];
var baseName = function (filename) { return filename.replace(/\.[^.]+$/, ''); };
var previewSrc = function (f) { return "/photos/preview/".concat(baseName(f)); };
var lightboxSrc = function (f) { return "/photos/lightbox/".concat(baseName(f)); };
var Gallery = function (_a) {
    var language = _a.language;
    var _b = useState(null), selectedPhotoIndex = _b[0], setSelectedPhotoIndex = _b[1];
    var openSlider = function (index) {
        setSelectedPhotoIndex(index);
    };
    var closeSlider = function () {
        setSelectedPhotoIndex(null);
    };
    var goToPrevious = function () {
        if (selectedPhotoIndex !== null && selectedPhotoIndex > 0) {
            setSelectedPhotoIndex(selectedPhotoIndex - 1);
        }
    };
    var goToNext = function () {
        if (selectedPhotoIndex !== null && selectedPhotoIndex < photoFiles.length - 1) {
            setSelectedPhotoIndex(selectedPhotoIndex + 1);
        }
    };
    // Keyboard navigation
    useEffect(function () {
        var handleKeyDown = function (e) {
            if (selectedPhotoIndex === null)
                return;
            if (e.key === 'ArrowLeft') {
                goToPrevious();
            }
            else if (e.key === 'ArrowRight') {
                goToNext();
            }
            else if (e.key === 'Escape') {
                closeSlider();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () { return window.removeEventListener('keydown', handleKeyDown); };
    }, [selectedPhotoIndex]);
    return (_jsxs("section", { className: "gallery-section", id: "gallery", children: [_jsxs("div", { className: "gallery-container", children: [_jsx("h2", { children: language === 'bg' ? 'ГАЛЕРИЯ' : 'GALLERY' }), _jsx("div", { className: "gallery-grid", children: photoFiles.map(function (file, index) { return (_jsxs("div", { className: "gallery-item", onClick: function () { return openSlider(index); }, children: [_jsxs("picture", { children: [_jsx("source", { srcSet: withVersion("".concat(previewSrc(file), ".webp")), type: "image/webp" }), _jsx("img", { src: withVersion("".concat(previewSrc(file), ".jpg")), alt: "Gallery ".concat(index + 1), loading: "lazy" })] }), _jsx("div", { className: "gallery-item-overlay", children: _jsx("span", { className: "zoom-icon", children: "\uD83D\uDD0D" }) })] }, index)); }) })] }), selectedPhotoIndex !== null && (_jsx("div", { className: "gallery-slider-overlay", onClick: closeSlider, children: _jsxs("div", { className: "gallery-slider-content", onClick: function (e) { return e.stopPropagation(); }, children: [_jsx("button", { className: "slider-close", onClick: closeSlider, children: "\u2715" }), _jsx("button", { className: "slider-nav slider-prev", onClick: goToPrevious, disabled: selectedPhotoIndex === 0, children: "\u2039" }), _jsxs("div", { className: "slider-image-container", children: [_jsxs("picture", { children: [_jsx("source", { srcSet: withVersion("".concat(lightboxSrc(photoFiles[selectedPhotoIndex]), ".webp")), type: "image/webp" }), _jsx("img", { src: withVersion("".concat(lightboxSrc(photoFiles[selectedPhotoIndex]), ".jpg")), alt: "Gallery ".concat(selectedPhotoIndex + 1) })] }), _jsxs("div", { className: "slider-counter", children: [selectedPhotoIndex + 1, " / ", photoFiles.length] })] }), _jsx("button", { className: "slider-nav slider-next", onClick: goToNext, disabled: selectedPhotoIndex === photoFiles.length - 1, children: "\u203A" })] }) }))] }));
};
export default Gallery;
